export default {
  leaveRequestStatus: {
    1: 'Request Cancelling',
    2: 'Pending',
    3: 'Rejected',
    4: 'Approved',
    5: 'Approved',
    6: 'HR Rejected',
    7: 'HR Pending',
    8: 'HR Review',
    9: 'Transfered',
    10: 'Deleted'
  },
  stationeryStatus: {
    0: 'Waiting',
    1: 'Ready for delivery',
    2: 'Delivered'
  },
  permissions: {
    ViewReportVote: [
      'khanh.nguyen@squaregroup.com.vn',
      'anh.phan@squaregroup.com.vn'
    ],
    ManageMeetingRoom: 'Backend.OfficeAdmin.MeetingRoom.Manage',
    ManageStationery: 'Backend.OfficeAdmin.Stationery.Manage',
    ManageCms: 'Backend.Cms.Manage',
    // ManageCms: ['Backend.Cms.Manage',
    //   'Backend.Cms.ArticleCategory.Manage',
    //   'Backend.Cms.Article.Manage'
    // ],
    HumanCapital: 'Backend.HR.Manage',
    // HumanCapital: [
    //   'Backend.Account.Manage',
    //   'Backend.Account.Role.Manage',
    //   'Backend.Account.User.Manage',
    //   'Backend.Account.UserGroup.Manage',
    //   'Backend.Admin.Manage',
    //   'Backend.Core.Parameter',
    //   'Backend.Hrm.Birthday.Manage',
    //   'Backend.Hrm.Branch.Manage',
    //   'Backend.Hrm.Company.Manage',
    //   'Backend.Hrm.Department.Manage',
    //   'Backend.Hrm.Employee.Manage',
    //   'Backend.Hrm.Employee.Manage.BookLeaveRequest',
    //   'Backend.Hrm.Employee.Manage.UpdateStaffID',
    //   'Backend.Hrm.Holiday.Manage',
    //   'Backend.Hrm.JobTitle.Manage',
    //   'Backend.Hrm.LeaveReport.Manage',
    //   'Backend.Hrm.LeaveRequest.Executive',
    //   'Backend.Hrm.LeaveRequest.Manage',
    //   'Backend.Hrm.LeaveType.Manage',
    //   'Backend.Hrm.Manage',
    //   'Backend.Hrm.Position.Manage',
    //   'Backend.Hrm.Report.Manage',
    //   'Backend.Hrm.Team.Manage',
    //   'Backend.Mdm.Bank.Manage',
    //   'Backend.Mdm.Continent.Manage',
    //   'Backend.Mdm.Country.Manage',
    //   'Backend.Mdm.Currency.Manage',
    //   'Backend.Mdm.District.Manage',
    //   'Backend.Mdm.Language.Manage',
    //   'Backend.Mdm.Manage',
    //   'Backend.Mdm.Partner.Manage',
    //   'Backend.Mdm.Province.Manage',
    //   'Backend.Mdm.ServiceCategory.Manage',
    //   'Backend.Mdm.ServiceIndustry.Manage',
    //   'Backend.Mdm.ServiceSubcategory.Manage',
    //   'Backend.MyTool.Feedback',
    //   'Backend.OfficeAdmin.TaxiCards.Manage',
    //   'Backend.Password.Change',
    //   'Backend.Pms.Config',
    //   'CB.CongDoan.GetListCongDoan',
    //   'CB.Constraint.CloseTimesheet',
    //   'CB.Delegate',
    //   'CB.EmployeeODTS.CalculateODTS',
    //   'CB.EmployeeODTS.Index',
    //   'CB.EmployeeSalary.EmployeePayroll',
    //   'CB.EmployeeSalary.EmployeePayroll_ByEmployeeId',
    //   'CB.EmployeeSalary.ExportPayroll',
    //   'CB.EmployeeSalary.ExportPayroll_ODTS',
    //   'CB.EmployeeSalary.ExportPayroll_Termination',
    //   'CB.EmployeeSalary.GetContentProcessById',
    //   'CB.EmployeeSalary.GuiDuyetPayroll',
    //   'CB.EmployeeSalary.Index',
    //   'CB.EmployeeTax.GetListEmployeeTax',
    //   'CB.EmployeeTermination.CalculateTermination',
    //   'CB.EmployeeTermination.Index',
    //   'CB.General.CreateCriteria',
    //   'CB.General.GeneralList',
    //   'CB.Insurance.ListInsurance',
    //   'CB.OtherInfo.GetListOtherInfo',
    //   'CB.OverTime.Create',
    //   'CB.OverTime.Delete',
    //   'CB.OverTime.Edit',
    //   'CB.OverTime.GetOverTimeList',
    //   'CB.OverTime.Index',
    //   'CB.Payroll_OtherInfo.Create',
    //   'CB.Payroll_OtherInfo.Delete',
    //   'CB.Payroll_OtherInfo.Edit',
    //   'CB.Payroll_OtherInfo.Index',
    //   'CB.Payrun.Copy',
    //   'CB.Payrun.Create',
    //   'CB.Payrun.Delete',
    //   'CB.Payrun.Edit',
    //   'CB.Payrun.Index',
    //   'CB.PayrunInsurance.Create',
    //   'CB.PayrunInsurance.Delete',
    //   'CB.PayrunInsurance.Edit',
    //   'CB.PayrunParameter.Create',
    //   'CB.PayrunParameter.Delete',
    //   'CB.PayrunParameter.Edit',
    //   'CB.PayrunTax.Create',
    //   'CB.PayrunTax.Delete',
    //   'CB.PayrunTax.Edit',
    //   'CB.ProcessSalaryApproval',
    //   'CB.Report',
    //   'CB.Transfer.View'
    // ]
  },
  api: {
    production: {
      // Server Linux
      news: 'https://api.dsquare.com.vn/mysquare/news',
      general: 'https://api.dsquare.com.vn/mysquare/general',
      meetingRoom: 'https://api.dsquare.com.vn/mysquare/meetingroom',
      profile: 'https://api.dsquare.com.vn/mysquare/profile',
      stationery: 'https://api.dsquare.com.vn/mysquare/stationery',
      // Server Windows
      pre: 'https://hr.mysquare.squaregroup.com.vn/api',
      imageDomain: 'https://mysquare.squaregroup.com.vn/',
      mainUrl: 'https://hr.mysquare.squaregroup.com.vn',
      urlDownloadPaySlip:
        'https://hr.mysquare.squaregroup.com.vn/Inside/Hrm/PaySlip/Export/',
      // urlDownloadLeaveRequest: '/Inside/Hrm/LeaveRequest/Export',
      urlDownloadLeaveRequest:
        'https://app.hc360.vn:8443/JasperReportsIntegration/report',
      //hc360: 'https://project.hc360.vn/ords/squarews/square',
      hc360: 'https://hcis.squaregroup.com.vn/ords/squarews/square',
      urlDownloadPaySlipHC360: 'https://app.hc360.vn/'

      // // Staging - Testing
      // news: 'https://api-mysquare.dsquare.vn/mysquare/news',
      // general: 'https://api-mysquare.dsquare.vn/mysquare/general',
      // meetingRoom: 'https://api-mysquare.dsquare.vn/mysquare/meetingroom',
      // profile: 'https://api-mysquare.dsquare.vn/mysquare/profile',
      // stationery: 'https://api-mysquare.dsquare.vn/mysquare/stationery',
      // Server Windows
      // pre: 'http://pre.ms.dsquare.vn/api',
      // imageDomain: 'http://pre.ms.dsquare.vn/',
      // mainUrl: 'http://pre.ms.dsquare.vn',
      // urlDownloadPaySlip: 'http://pre.ms.dsquare.vn/Inside/Hrm/PaySlip/Export/',
      // hc360: 'https://project.hc360.vn/ords/squarews/square',
      // urlDownloadLeaveRequest: '/Inside/Hrm/LeaveRequest/Export',
      // urlDownloadLeaveRequest:
      //   'http://hcis.squaregroup.com.vn:8080/JasperReportsIntegration/report',
    },
    development: {
      // news: 'https://api-mysquare.dsquare.vn/mysquare/news',
      // general: 'https://api-mysquare.dsquare.vn/mysquare/general',
      // meetingRoom: 'https://api-mysquare.dsquare.vn/mysquare/meetingroom',
      // profile: 'https://api-mysquare.dsquare.vn/mysquare/profile',
      // stationery: 'https://api-mysquare.dsquare.vn/mysquare/stationery',
      // pre: 'http://pre.ms.dsquare.vn/api',
      // imageDomain: 'http://pre.ms.dsquare.vn/',
      // mainUrl: 'http://pre.ms.dsquare.vn',
      // urlDownloadPaySlip: 'http://pre.ms.dsquare.vn/Inside/Hrm/PaySlip/Export/',
      // urlDownloadPaySlipHC360: 'https://hcis.squaregroup.com.vn:8443',
      // urlDownloadLeaveRequest: '/Inside/Hrm/LeaveRequest/Export',
      // // urlDownloadLeaveRequest:
      // //   'http://hcis.squaregroup.com.vn:8080/JasperReportsIntegration/report',
      // hc360: 'https://project.hc360.vn/ords/squarews/square'
      // // hc360: 'https://www.hrjob.vn/ords/hc360dev/square'

      // Server Linux
      news: 'https://api-mysquare.dsquare.vn/mysquare/news',
      general: 'https://api.dsquare.com.vn/mysquare/general',//up
      meetingRoom: 'https://api.dsquare.com.vn/mysquare/meetingroom',
      profile: 'https://api.dsquare.com.vn/mysquare/profile',//up
      stationery: 'http://stationery.api.p17012.dsquare.vn',
      // Server Windows
      //pre: 'https://hr.mysquare.squaregroup.com.vn/api',
      pre: 'https://hcis.squaregroup.com.vn/ords/squarews/square',//up
      imageDomain: 'https://hr.mysquare.squaregroup.com.vn/',
      mainUrl: 'https://hr.mysquare.squaregroup.com.vn',
      urlDownloadPaySlip:
        'https://hr.mysquare.squaregroup.com.vn/Inside/Hrm/PaySlip/Export/',
      urlDownloadLeaveRequest:
        'http://hcis.squaregroup.com.vn:8080/JasperReportsIntegration/report',
        //hc360: 'https://project.hc360.vn/ords/squarews/square'
        hc360: 'https://hcis.squaregroup.com.vn/ords/squarews/square',
        urlDownloadPaySlipHC360: 'https://app.hc360.vn/'
      // // Staging - Testing
      // news: 'http://news.api.p17012.dsquare.vn',
      // general: 'http://general.api.p17012.dsquare.vn',
      // meetingRoom: 'http://meetingroom.api.p17012.dsquare.vn',
      // profile: 'http://profile.api.p17012.dsquare.vn',
      // stationery: 'http://stationery.api.p17012.dsquare.vn',
      // pre: 'http://pre.ms.dsquare.vn/api',
      // imageDomain: 'http://pre.ms.dsquare.vn/',
      // mainUrl: 'http://pre.ms.dsquare.vn',
      // urlDownloadPaySlip: 'http://pre.ms.dsquare.vn/Inside/Hrm/PaySlip/Export/',
      // urlDownloadLeaveRequest: '/Inside/Hrm/LeaveRequest/Export',
      // hc360: 'https://project.hc360.vn/ords/squarews/square'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/config.js